module.exports = __webpack_public_path__ + "static/media/inputLayer.8f5531a5.svg";